export default {"src":"/_next/static/media/coco-happy.6727dd37.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};